import React, { useState } from "react";
import Avatar from "../assets/images/photo.jpg";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { storage } from "../config/firebaseConfig";

function FormAddPhotos() {
  const [photoUpload, setPhotoUpload] = useState(null);
  const [previewPhotoUpload, setPreviewPhotoUpload] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleAvatar = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setPhotoUpload(file);

      const reader = new FileReader();
      reader.onload = (e) => {
        let imgDataUrl = null;
        if (e.target) {
          imgDataUrl = e.target.result;
        }
        setPreviewPhotoUpload(imgDataUrl);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCategoryChange = (e) => {
    setSelectedCategory(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);

    if (!photoUpload) {
      alert("Veuillez sélectionner une photo à uploader.");
      setUploading(false);
      return;
    }

    if (!selectedCategory) {
      alert("Veuillez sélectionner une catégorie.");
      setUploading(false);
      return;
    }

    try {
      // 🔥 On stocke la photo dans un dossier correspondant à la catégorie sélectionnée
      const storageRef = ref(
        storage,
        `uploads/${selectedCategory}/${photoUpload.name}`
      );
      const snapshot = await uploadBytes(storageRef, photoUpload);
      const downloadURL = await getDownloadURL(snapshot.ref);

      console.log("Photo uploadée avec succès !");
      console.log("URL de téléchargement :", downloadURL);

      // Réinitialisation du formulaire
      setPhotoUpload(null);
      setPreviewPhotoUpload(null);
      setSelectedCategory("");
      alert("Photo uploadée avec succès !");
    } catch (error) {
      console.error("Erreur lors de l'upload :", error);
      alert("Erreur lors de l'upload de la photo.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <form className="form-photo" onSubmit={handleSubmit}>
      <div className="photo-upload">
        <label htmlFor="photoUpload">Fichier à Upload</label>
        <input
          type="file"
          name="photoUpload"
          id="photoUpload"
          onChange={handleAvatar}
          disabled={uploading}
        />
        <div className="category-select">
          <select
            name="category"
            id="category"
            value={selectedCategory}
            onChange={handleCategoryChange}
            disabled={uploading}
          >
            <option value="" disabled>
              CATEGORIES
            </option>
            <option value="sport">Sport</option>
            <option value="concert">Concert</option>
            <option value="mariage">Mariage</option>
            <option value="portrait">Portrait</option>
            <option value="shooting">Shooting</option>
            <option value="extérieur">Extérieur</option>
            <option value="paysage">Paysage</option>
          </select>
        </div>
      </div>
      <div className="img-photo-upload">
        <img
          className="img-upload"
          src={previewPhotoUpload ? previewPhotoUpload : Avatar}
          alt="avatar"
        />
      </div>
      <button type="submit" disabled={uploading}>
        {uploading ? "Uploading..." : "Enregistrer"}
      </button>
    </form>
  );
}

export default FormAddPhotos;
